import {useMutation, UseMutationResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";


const useApiCreateCompanyOrderSchedule = (companyToken: string | undefined, color_id: number | undefined): UseMutationResult<void, CustomAxiosError, any, unknown> => {

    const {post} = useApiCalls();

    async function doCreate({companyToken, color_id, data}: {
        companyToken?: string,
        color_id: number | undefined,
        data: any
    }): Promise<void> {
        try {
            await post(`/api/company/${companyToken}/tannery_production/order_schedule/${color_id}`, data);
        } catch (error) {
            throw error;
        }
    }

    return useMutation<void, CustomAxiosError, any>(
        {
            mutationFn: (data) => doCreate({companyToken, color_id, data})
        }
    );
};


export default useApiCreateCompanyOrderSchedule;